// App root — wouter routes matching OMNI's pattern

import { Route, Switch } from "wouter";
import { Shell } from "./components/Shell.js";
import { AuditLog } from "./views/AuditLog.js";
import { Login } from "./views/Login.js";
import { MyPeers } from "./views/MyPeers.js";
import { PeerAssign } from "./views/PeerAssign.js";
import { PeerDashboard } from "./views/PeerDashboard.js";

export function App() {
	return (
		<Switch>
			{/* Login page — no shell */}
			<Route path="/login" component={Login} />

			{/* Authenticated routes — wrapped in Shell */}
			<Route>
				<Shell>
					<Switch>
						<Route path="/" component={PeerDashboard} />
						<Route path="/my-peers" component={MyPeers} />
						<Route path="/peers/:ip/assign" component={PeerAssign} />
						<Route path="/audit" component={AuditLog} />
						<Route>
							<PeerDashboard />
						</Route>
					</Switch>
				</Shell>
			</Route>
		</Switch>
	);
}
